import * as React from "react";
import { NonIdealState } from "@blueprintjs/core";

export default class UnexpectedBackendError extends React.PureComponent {
  render() {
    return (
      <NonIdealState
        icon="error"
        title="Error"
        className="backend-error"
        description={
          <>
            We encountered an unexpected error. We've been notified of the problem, but please send
            us a <a href="mailto:support@onecodex.com">note</a> if you continue to have issues.
          </>
        }
      />
    );
  }
}
